import {Box, Typography} from '@mui/material';

import {PropsWithChildren} from 'react';
import {Warning as WarningIcon} from '@mui/icons-material';
import {useResponsive} from '../../provider/MediaQueryProvider';

type FrameProps = {
    title: string;
    children: JSX.Element;
    fullWidth?: boolean;
};

export function Frame(props: FrameProps) {
    const {isMobile, isTablet} = useResponsive();
    return (
        <Box
            sx={{
                border: '1px solid #ccc',
                borderRadius: '5px',
                boxShadow: 3,
                padding: '20px',
                maxWidth: 'min(500px, 100%)',
                margin: 'auto',
                marginTop: '20px',
                width: props.fullWidth ? '100%' : 'auto',
            }}
        >
            <Typography fontWeight={'bold'}>{props.title}</Typography>
            {props.children}
        </Box>
    );
}

export function Warning(props: PropsWithChildren<{}>) {
    return (
        <Box
            style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: 30,
                backgroundColor: '#fecaca',
                padding: 10,
                borderRadius: 10,
                color: '#991b1b',
                marginTop: 20,
            }}
        >
            <WarningIcon />
            {props.children}
        </Box>
    );
}
